import "./ShivRatri.css";
// import cancelIcon from "/Xicon.png";
import shiva from "../../../../assets/images/shiva.png"

 export const ShivRatriPopup =(props)=>{
    return(
      <>
       <div class="spinning-animation-sv"></div>
        <div className="row" style={{ position: "relative" ,maxWidth:"270px" }}>
        <div class="background-card-sv"></div>      
        <div
          className="content-card-sv"
          style={{ borderRadius: "13px", border: "1px solid #4CF038",}}
        >
          <div style={{ position: "relative", width: "100%" }}>
            <img
              src='https://d1ccopf5cw1hft.cloudfront.net/s3data/shiva.png'
              style={{
                zIndex: "1",
                width: "100%",
                height: "100%",
                display: "block",
                borderRadius: "24px",
              }}
              alt="Background"
            />
            <div id="black-overlay-sv"></div>
            <h1 className="whats-new-sv" data-text="WHAT'S NEW">
              WHAT'S NEW
            </h1> 
            <div id="black-overlay-bottom"></div>
          </div>
          <div className="text_container-sv">
            <p className="pre_text-sv">On this Maha Shivaratri! Experience <span className="sv-energy">infinite energy</span>  with every tap!</p>
            
           
          </div>
          <button
 onClick={props?.IsEnergyPopupClose}   
            className="redeem-button-sv"
          >
           <p>#doNothing</p>
          </button>
        </div>
        <button
          style={{
            background: "transparent",
            border: "none",
            height: "24px",
          }}
        >
          <img  
            onClick={props?.IsEnergyPopupClose}
            src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
            className="cancel_button-sv"
            alt="cancel"
          />
        </button>
      </div>


      </>
     
    )
}
